import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '@app/environments/environment';
import { MakeHttpParams } from '@app/app/shared/helpers/params.helper';
import { WeatherInterface } from '@app/app/shared/interfaces/weather.interface';

@Injectable()
export class WeatherService {
  constructor(private http: HttpClient) {
  }

  public fetchByCoords(params: { latitude: string | number, longitude: string | number }): Observable<WeatherInterface> {
    return this.http.get<WeatherInterface>(environment.weather.url, {
      params: MakeHttpParams({lat: params.latitude, lon: params.longitude}).set('appid', environment.weather.appid).set('units', 'metric')
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/weather.service.ts